document.addEventListener('DOMContentLoaded', () => {
    const sliders = Array.from(document.querySelectorAll('.testimonials-sidebar'));

    sliders.forEach(slider => {
        const testimonialsContainer = slider.querySelector('.testimonials-content');
        const testimonials = Array.from(testimonialsContainer.querySelectorAll('.testimonial-single'));
        const prevButton = slider.querySelector('.prev');
        const nextButton = slider.querySelector('.next');

        if (!prevButton || !nextButton) {
            return;
        }

        let currentIndex = 0;
        const totalTestimonials = testimonials.length;

        updateSliderPosition();

        prevButton.addEventListener('click', showPreviousTestimonial);
        nextButton.addEventListener('click', showNextTestimonial);

        function showNextTestimonial() {
            currentIndex = (currentIndex + 1) % totalTestimonials;
            updateSliderPosition();
        }

        function showPreviousTestimonial() {
            currentIndex = (currentIndex - 1 + totalTestimonials) % totalTestimonials;
            updateSliderPosition();
        }

        function updateSliderPosition() {
            const offsetPercentage = -currentIndex * 100;
            testimonialsContainer.style.transform = `translateX(${offsetPercentage}%)`;
        }
    });
});
